<div class="container-fluid bg-white">
  <div class="row">
    <main class="col-12 px-md-4" style="padding-right: 12px !important; height: 100vh;">
      <!-- Header -->
      <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2">
        @if(this.isLoading){
        <div class="spinner-border" role="status" style="margin-right: 8px;">
          <span class="sr-only"></span>
        </div>
        }
      </div>
      <div class="tab-content" id="myTabContent">
        <!-- Sections -->
        <div class="row">
          <div class="table-responsive col-12" style="margin-right: 0px; padding-left: 16px; margin-top: 16px; overflow: hidden scroll; max-height: calc(100vh - 120px);">
            <table class="table table-striped table-hover">
              <thead class="sticky-top-header">
                <tr>
                  <th scope="col">Company</th>
                  <th scope="col">Project</th>
                  <th scope="col">Name</th>
                  <th scope="col">Date</th>
                  <th scope="col">Status</th>
                </tr>
              </thead>
              <tbody>
                @for (review of this.reviews?.results; track review.id) {
                <tr (click)="this.onRowClick(review.id)" style="cursor: pointer;">
                  <td>{{review.companyNumber}}</td>
                  <td>{{review.projectId}}</td>
                  <td>{{review.projectName}}</td>
                  <td>{{review.issuedDate | date }}</td>
                  <td>{{review.status}}</td>
                </tr>
                } @empty {
                <tr>
                  <td colspan="5" style="text-align: center;">
                    @if (this.isLoading){
                    Loading...
                    } @else {
                    No Reviews
                    }
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </main>
  </div>
</div>
